import {
  ERROR_CLEARALL,
  LOGOUT_SUCCESS,
  SET_ACCESS_MENU,
  SET_AGENT_PERMISSION,
  SET_ERROR,
  SET_LOGOUT_CLEAR,
  SET_INBOUND_SAVE_TICKET,
  SET_SIP_PARAM,
  SET_STATUSNCOLOR,
  SET_STATUSNCOLOR_CLEAR,
  SUCCESS_MESSAGE_CLEAR,
  USER_LOGIN_FAIL,
  USER_LOGIN_SUCCESS,
} from "../Types/AuthTypes";

import deCodeToken from "jwt-decode";

const authState = {
  accessMenu: [],
  agentPermission: [],
  authenticate: false,
  CurrentColor: "",
  CurrentState: "",
  errorMessageAuth: "",
  inboundSaveTicket: "",
  loading: true,
  myInfo: "",
  sipAccount: {},
  sipParam: "",
  successMessageAuth: "",
};

const initialState = JSON.parse(JSON.stringify(authState));

const tokenDecode = (token) => {
  const tokenDecoded = deCodeToken(token);
  const expTime = new Date(tokenDecoded.exp * 1000);

  if (new Date() > expTime) {
    return null;
  }

  return tokenDecoded;
};

const getToken = localStorage.getItem("token");

if (getToken) {
  const getInfo = tokenDecode(getToken);

  if (getInfo) {
    authState.myInfo = getInfo;
    authState.authenticate = true;
    authState.loading = false;
  }
}

// const getCurrentState = localStorage.getItem("container");
const getCurrentState = JSON.parse(
  localStorage.getItem("agentStatus")
)?.container;
if (getCurrentState) {
  authState.CurrentState = getCurrentState;
}
// const getCurrentColor = localStorage.getItem("colors");
const getCurrentColor = JSON.parse(localStorage.getItem("agentStatus"))?.colors;
if (getCurrentColor) {
  authState.CurrentColor = getCurrentColor;
}

export const authReducer = (state = authState, action) => {
  const { payload, type } = action;

  if (type === ERROR_CLEARALL) {
    return {
      ...state,
      authenticate: false,
      errorMessageAuth: "",
    };
  }

  if (type === LOGOUT_SUCCESS) {
    state = initialState;

    return {
      ...state,
      successMessageAuth: "Logout Successful",
    };
  }

  if (type === SET_ACCESS_MENU) {
    return {
      ...state,
      accessMenu: payload,
    };
  }

  if (type === SET_AGENT_PERMISSION) {
    return {
      ...state,
      agentPermission: payload,
    };
  }

  if (type === SET_ERROR) {
    return {
      ...state,
      errorMessageAuth: payload.errorMessage,
    };
  }

  if (type === SET_INBOUND_SAVE_TICKET) {
    return {
      ...state,
      inboundSaveTicket: payload,
    };
  }

  if (type === SET_LOGOUT_CLEAR) {
    return {
      ...state,
      CurrentState: "",
      CurrentColor: "",
      LastState: "",
      LastStateReason: "",
      LastStateTime: "",
    };
  }

  if (type === SET_SIP_PARAM) {
    return {
      ...state,
      sipParam: payload,
    };
  }

  if (type === SET_STATUSNCOLOR) {
    return {
      ...state,
      CurrentState: payload.CurrentState,
      CurrentColor: payload.CurrentColor,
    };
  }

  if (type === SET_STATUSNCOLOR_CLEAR) {
    return {
      ...state,
      CurrentState: "",
      CurrentColor: "",
    };
  }

  if (type === SUCCESS_MESSAGE_CLEAR) {
    return {
      ...state,
      successMessageAuth: "",
    };
  }

  if (type === USER_LOGIN_FAIL) {
    return {
      ...state,
      errorMessageAuth: payload.errorMessage,
      authenticate: false,
      myInfo: "",
      loading: true,
    };
  }

  if (type === USER_LOGIN_SUCCESS) {
    const myInfo = tokenDecode(payload.token);
    return {
      ...state,
      myInfo: myInfo,
      successMessageAuth: payload.successMessage,
      errorMessageAuth: "",
      authenticate: true,
      loading: false,
      sipAccount: payload.sipAccount,
    };
  }

  return state;
};
